import { InboxIcon, TrashIcon, UsersIcon } from '@heroicons/react/24/outline';
import { values } from '../../data';

export default function CoreValues() {
	return (
		<div className='bg-white py-24 sm:py-32'>
			<div className='mx-auto max-w-7xl px-6 lg:px-8'>
				<div className=''>
					<h2 className='text-pretty text-center text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl'>
						Our Core Values
					</h2>
				</div>
				<div className='mx-auto mt-16 sm:mt-20 lg:mt-24 lg:max-w-none'>
					<dl className='grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-4 text-center'>
						{values.map((value) => (
							<div
								key={value.name}
								className='flex flex-col items-center text-center'
							>
								<div className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary mb-4'>
									<value.icon
										aria-hidden='true'
										className='h-6 w-6 text-white'
									/>
								</div>
								<dt className='text-base font-semibold text-gray-900'>{value.name}</dt>
							</div>
						))}
					</dl>
				</div>
			</div>
		</div>
	);
}
